import { takeLatest, call, put } from 'redux-saga/effects';
import * as boardActions from 'redux/ducks/Board/BoardDucks';
import boardApi from 'api/board/boardApi';
import portalApi from 'api/portal/portalApi';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* createBoard({ payload }) {
  try {
    const response = yield call(boardApi.crateBoard, payload);
    yield put(boardActions.createBoardSuccess(response));
    if (payload.portlet === 'N') {
      yield put(boardActions.updateBoardList({ portlet: payload.portlet }));
    }
  } catch (error) {
    yield put(boardActions.createBoardFail(error));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getTopMenuList({ payload }) {
  try {
    let param = `${payload.compCd ? `compCd=${payload.compCd}` : ``}`;
    param = `${payload.suborgCd ? `${param}&suborgCd=${payload.suborgCd}` : `${param}`}`;
    param = `${payload.dfltTopMenuYn ? `${param}&dfltTopMenuYn=${payload.dfltTopMenuYn}` : `${param}`}`;
    param = `${payload.useYn ? `${param}&useYn=${payload.useYn}` : `${param}`}`;
    const response = yield call(boardApi.getTopMenu, param);
    yield put(boardActions.getTopMenuListSuccess(response));
  } catch (error) {
    yield put(
      alertActions.open({
        message: [error.errorCode.split('.')[1]],
      }),
    );
  }
}

export function* addBoardList() {
  try {
    const response = yield call(boardApi.listCompByLvl);
    yield put(boardActions.addBoardListSuccess(response));
  } catch (error) {
    yield put(boardActions.addBoardListFail(error));
  }
}

export function* deleteBoard({ payload }) {
  try {
    const response = yield call(boardApi.deleteBoard, payload);
    yield put(boardActions.deleteBoardSuccess(response));
    yield put(boardActions.removeBoardList(payload));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* createPortlet({ payload }) {
  try {
    const response = yield call(portalApi.createPortlet, payload);
    yield put(boardActions.createPortletSuccess(response));
    yield put(boardActions.updateBoardList({ portlet: 'Y' }));
  } catch (error) {
    yield put(boardActions.createPortletFail(error));
  }
}

export function* deletePortlet({ payload }) {
  try {
    const response = yield call(portalApi.deletePortlet, payload);
    yield put(boardActions.deletePortletSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* createCategory({ payload }) {
  try {
    const response = yield call(portalApi.createCategory, payload);
    if (response.result === 'success') {
      yield put(boardActions.createCategorySuccess(response));
    } else {
      yield put(boardActions.createCategoryFail(response.error));
      yield put(alertActions.open({ message: [response.error.errorCode] }));
    }
  } catch (error) {
    yield put(boardActions.createCategoryFail(error));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* arrangePortlet({ payload }) {
  try {
    const response = yield call(portalApi.arrangePortlet, payload);
    yield put(boardActions.arrangePortletSuccess(response));
  } catch (error) {
    yield put(boardActions.arrangePortletFail(error));
  }
}

export default function* BoardSaga() {
  yield takeLatest(boardActions.createBoard, createBoard);
  yield takeLatest(boardActions.getTopMenuList, getTopMenuList);
  yield takeLatest(boardActions.addBoardList, addBoardList);
  yield takeLatest(boardActions.deleteBoard, deleteBoard);
  yield takeLatest(boardActions.createPortlet, createPortlet);
  yield takeLatest(boardActions.createCategory, createCategory);
  yield takeLatest(boardActions.arrangePortlet, arrangePortlet);
  yield takeLatest(boardActions.deletePortlet, deletePortlet);
}
